import { MUIDataTableMeta } from 'mui-datatables';
import React from 'react';
import { CheckboxTable } from '../Checkbox';
import { ISupplierContact } from 'pages/formsCreate/types';

interface IProps {
  suppliersContactList: ISupplierContact[];
  selectedSuppliers: any[];
  handleSelectSuppliers: (supplierId: string) => void;
}

export const tableHeaders = ({ handleSelectSuppliers, suppliersContactList, selectedSuppliers }: IProps) => {
  return [
    {
      name: 'select',
      label: 'Selecionar',
      options: {
        filter: false,
        customBodyRender: (value: any, metadata: MUIDataTableMeta) => {
          return (
            <CheckboxTable
              onChange={handleSelectSuppliers}
              metadata={metadata}
              suppliersContactList={suppliersContactList}
              selectedSuppliers={selectedSuppliers}
            />
          );
        }
      }
    },
    {
      name: 'ID_PESSOA',
      label: 'ID Pessoa'
    },
    {
      name: 'NM_PESSOA',
      label: 'Fornecedor'
    },
    { name: 'RET_EMAIL_PESSOA', label: 'Email' }
  ];
};
